import { useQuery } from '@tanstack/react-query';

import { getTrades } from '~apis/trade/getTrades';

const USE_GET_TRADES_QUERY = {
  root: ['trades'],
  default: (companyId: string) => [...USE_GET_TRADES_QUERY.root, companyId],
};
export default function useTradesQuery(size: number, page: number, companyId?: string) {
  return useQuery(
    USE_GET_TRADES_QUERY.default(companyId as string),
    () => getTrades(companyId as string, size, page),
    {
      enabled: !!companyId,
    },
  );
}
